import './GoogleLoginButton.css';

const GoogleLoginButton = ({ userType, disabled = false }) => {
const API_URL = process.env.REACT_APP_BACKEND_URL;

  const handleGoogleLogin = () => {
    if (disabled) return;
    window.location.href = `${API_URL}/auth/google/${userType}`;
  };

  // Capitalize first letter of userType
  const capitalizedUserType = userType.charAt(0).toUpperCase() + userType.slice(1);
  return (
    <button 
      onClick={handleGoogleLogin} 
      className="google-login-button"
      disabled={disabled}
    >
      {/* Base64 encoded Google icon as fallback */}
      <img 
        src="/google-icon.png" 
        alt="Google" 
        className="google-icon"
        onError={(e) => {
          e.target.style.display = 'none';
        }}
      />
      Continue with Google ({capitalizedUserType})
    </button>
  );
};

export default GoogleLoginButton;